import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

// Trigger は button をレンダリングするため、入力欄のように自身がフォーカスを持つ要素を
// 中に置けない。位置合わせだけが要る場合はこちらを使い、開閉は呼び出し側が open で制御する。
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={twMerge(
        'z-50 w-72 rounded-md border bg-sem-l-surf-primary p-4 text-sem-l-text-high shadow-md outline-none',
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
